module.exports = require('./helpers/bundle-url').getBundleURL('2DEgY') + "logo-dark.eefe0b7f.svg";